import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    active: {
      type: Number,
      default: 1
    }
  }
};